import { IconButton, Popover, Typography } from "@mui/material";
import { CalendarToday } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { Box } from "@mui/system";
import { format, startOfDay, endOfDay } from "date-fns";
import { useState } from "react";
import { isPast } from "date-fns";
import { isToday } from "date-fns";
import { useTheme } from "../../ThemeContext";

export const CustomTasksCalender = ({ selectionRange, setSelectionRange ,publish}) => {
  const [open, setOpen] = useState(false);
  const { isDarkMode } = useTheme();

  const handleDateSelect = (date) => {
    const newRange = {
      startDate: startOfDay(date),
      endDate: endOfDay(date),
      key: "selection",
    };

    setSelectionRange(newRange);
    setOpen(false);
  };
    const shouldDisableDate = (date) => {
    if (!publish) return false;
    return isPast(date) || isToday(date);
  };

  return (
    <Box display="flex" alignItems="center">
      <IconButton onClick={() => setOpen(true)}>
        {/* <CalendarToday sx={{ fontSize: 20, color: "black" }} /> */}
        <CalendarToday sx={{ fontSize: 20, color: isDarkMode ? "white" : "black" }} />
      </IconButton>

      <Typography
        variant="body1"
        onClick={() => setOpen(true)}
        sx={{
          cursor: "pointer",
          fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" },
          // color: "black",
          color: isDarkMode ? "white" : "black",
        }}
      >
        {format(selectionRange.startDate, "dd/MM/yyyy")}
      </Typography>

      {/* Calendar Popover */}
      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchorReference="none"
        PaperProps={{
          style: {
            padding: "0px",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            position: "absolute",
            overflow: "hidden",
            borderRadius: "8px",
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateCalendar
            value={selectionRange.startDate}
            onChange={handleDateSelect}
            shouldDisableDate={shouldDisableDate}
          />
        </LocalizationProvider>
      </Popover>
    </Box>
  );
};
